import { Helmet } from 'react-helmet-async';
import { useState } from "react";
import { HiOutlineBookOpen } from "react-icons/hi";
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs'

const AboutMijsc = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
      <Helmet>
        <title>About MIJSC | Our Mission & Vision</title>
        <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
      </Helmet>
      <BreadCrumbs />

      <div className=' w-[94%] text-justify'>
        <section className='w-full h-fit md:mx-10 mx-5 mb-5 ' >
          <h1 className="md:text-4xl text-lg mt-10 mb-10 font-semibold uppercase text-left">Mizuho India Japan <br />
            <span className="text-green-600">Study Centre</span>
          </h1>
        </section>
      </div>

      <section
        className=" mx-5 pb-10"
        aria-label="About MIJSC"
      >
        <div className="flex flex-col md:flex-row md:gap-2 text-left items-center">
          {/* LEFT: image + floating card */}
          <div
            className="relative flex-[0_0_48%] min-w-[280px]"
            aria-hidden="false">
            <img src="/assets/physical-interactions.png" alt="MIJSC classroom and students" className="w-full h-full" />
          </div>

          {/* RIGHT: text area */}
          <div className="flex-[0_0_50%] min-w-[260px] mt-10 md:mt-0 md:pr-5 text-justify">
            <p className="text-gray-600 text-sm mb-4">
              India and Japan have shared a strong and productive history of bilateral development cooperation since 1958. With Japan's "Free and Open Indo-Pacific Strategy" and India's "Act East policy, the strategic and global alliance between the two nations is being strengthened, particularly in the areas of economic, cultural, and security cooperation.
            </p>

            <p className="text-gray-600 text-sm mb-4">
              In recent years, the economic partnership between India and Japan has continued to flourish. As of FY2023, bilateral trade between the two nations totolled approximately $21.96 billion, with Japan exporting goods worth $10.49 billion to India and importing $5.46 billion worth of goods from India.
            </p>

            <p className="text-gray-600 text-sm mb-4">
              Japan's involvement in India is extensive, particularly in sectors like infrastructure, aerospace, defence, and energy. The Shinkansen high-speed rail project, which is Japanese private sector interest in India remains strong, with around 1,500 Japanese companies operating over 5,000 branches across the country as of 2024
            </p>

            <p className="text-gray-600 text-sm mb-4">
              Development Assistance (ODA) to India, supporting various projects across education, health, manufacturing, transport, and more.
            </p>


          </div>
        </div>
      </section>


      <section className='study-centre md:pt-10 md:mx-10 mx-5 md:mb-10 text-left'>
        <div className='h-fit w-full md:flex gap-10'>
          <div className='flex-1'>
            <div className='flex items-center my-3 gap-3 mb-4 bg-green-600 w-fit px-5 py-2 rounded-full'>
              <p className='text-white  font-semibold text-xs md:text-3xl'> Japan In India</p>
            </div>

            <div>
              <p className="text-gray-600 text-sm mb-4 text-justify">
                IIMB hos years of ongoing research collaborations and student exchange programmes with some of the best Japanese business schools and universities, like Hitotsubashi University, International University of Japan, Keio University, Tokyo University, Kyoto University, and Waseda University. There are industry relationships and collaborations as well. IIMB offers elective course exclusively on Japan to its MBA students. Faculty ot IIMB are involved in Japan
                related
              </p>

            </div>
          </div>
        </div>

      </section>


      <section className='study-centre md:pt-20 md:mx-10 mx-5 md:mb-10 text-left '>
        <div className='md:h-[400px] h-fit w-full md:flex gap-10'>
          <div className='flex-1'>
            <div className='flex items-center my-3 gap-3 mb-4 bg-green-100 w-fit px-5 py-2 rounded-md'>
              <p className='text-green-700  font-semibold text-xs md:text-3xl'>Role of MIJSC</p>
            </div>

            <div>
              <p className="text-gray-600 text-sm mb-4 text-justify border-b-2 border-dashed border-gray-500 pb-4">
                With compelling business and national interests propelling the fast-evolving India-Japan business environment, IIMB with its academic and research competencies conceived the idea of establishing the Mizuho India Japan Study Centre to facilitate collaborative initiatives among academia, industry and government agencies of both countries to work on areas of mutual interest. These would include domains such as business environment, government policies, innovation, project management, sourcing, technology transfer, development and management, sustainability, intellectual property rights, and understanding of local culture and business practices. The sectoral focus would be an infrastructure including energy and transportation, and Micro, Small and Medium Enterprises. Currently, there is no focused initiative in India among academic institutes, particularly in mariagement institutes, to create, share and disseminate knowledge in the relevant areas of Inde-Japanese business. The Mizuho India Japan Study Centre IIMB aims to become a leading research and networking hub that would provide students, researchers, business managers and policy mokers with a deeper understanding of Japanese and Indian business. As a locotion, Bengaluru has the highest number of Japanese companies and professionals in India Further, its innovation ecosystem has been ranked among the world's best. Focused activities of the Mizuho India Japan Study Centre IIMB will be aimed at stimulating, strengthening and sustaining Indo-Japanese academic-business interactions.
              </p>


            </div>
          </div>
          <div className=' bg-green-900 h-full w-72 rounded-3xl bg-cover' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/about-mijsc/about-mijsc-4.png)` }}> </div>
        </div>


      </section>

      <section className="md:py-16 py-0 px-5 md:px-8 lg:px-10 bg-white ">
        <div className="mx-auto">
          <div className="text-center mb-14">
            <h2 className="md:text-4xl font-bold text-gray-800 mb-4">
              OBJECTIVES
            </h2>
            <p className="text-sm text-gray-600 max-w-3xl mx-auto font-medium">
              Comprehensive programs designed to bridge industry and academia
            </p>
          </div>


          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-left md:mt-0">
            <div className="bg-[#05976a] text-white  rounded-xl p-5 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col">
              <div className="flex-1">
                <h3 className="text-md font-bold mb-3">OBJECTIVE 1</h3>
                <p className="text-sm leading-relaxed opacity-95">
                  To become a knowledge centre of Japanese business history, business strategies, culture, and technology innovations.
                </p>
              </div>
            </div>


            <div className="bg-[#05976a] text-white  rounded-xl p-5 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col">
              <div className="flex-1">
                <h3 className="text-md font-bold mb-3">OBJECTIVE 2</h3>
                <p className="text-sm leading-relaxed opacity-95">
                  To initiate focused studies on India-Japan collaborative projects.
                </p>
              </div>
            </div>


            <div className="bg-[#05976a] text-white  rounded-xl p-5 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col">
              <div className="flex-1">
                <h3 className="text-md font-bold mb-3">OBJECTIVE 3</h3>
                <p className="text-sm leading-relaxed opacity-95">
                  To promote collaborative research between partnering Japanese institutes, industry and IIMB.
                </p>
              </div>
            </div>


            <div className="bg-[#05976a] text-white  rounded-xl p-5 shadow-3xl hover:shadow-xl transition-shadow duration-300 flex flex-col">
              <div className="flex-1">
                <h3 className="text-md font-bold mb-3">OBJECTIVE 4</h3>
                <p className="text-sm leading-relaxed opacity-95">
                  To host scholars from Japanese institutes of higher learning, practitioners from industry and policymakers.
                </p>
              </div>
            </div>




          </div>


          <div className="bg-[#05976a] mt-9 text-left text-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col md:justify-self-center">
            <div className="flex-1">
              <h3 className="text-md font-bold mb-3">OBJECTIVE 5</h3>
              <p className="text-sm leading-relaxed opacity-95">
                To disseminate the outcomes of academic research in the focused areas.
              </p>
            </div>
          </div>



        </div>
      </section>



    </div>
  )
}

export default AboutMijsc 
